module.exports = __webpack_public_path__ + "img/main-logo-dt.12f0a21f.png";